import { compose } from 'recompose';

import DropdownItemView from './DropdownItemView';

export default compose()(DropdownItemView);
